import PropTypes from "prop-types";

import type { RegisteredComponent } from "@builder.io/sdk-react";

const Text = ({ text }: { text: string }) => {
  return (
    // `hec-prose` (app/styles/app.css) holds the prose-* utility list. Inline,
    // it cost 1,104 bytes of HTML per Text block — Builder renders one per
    // authored text node, so ~294KB of the FSA homepage was this className.
    <div className="hec-prose">
      {/* Byte-identical to the SDK's own `Text` (a `.builder-text` div with
          the authored HTML and `outline: none`; the editor's inline editing
          targets the block wrapper, not this element), rendered here so it
          can carry `suppressHydrationWarning`: Builder-authored `jsCode`
          runs during the SDK's FIRST client render — before this subtree
          hydrates — and the alert-bar countdown's script rewrites its digit
          Text blocks' innerHTML (`<p>00</p>` → `<p>17</p>`). The DOM is the
          state we want; without the suppression React reports a mismatch
          on every hydration of the homepage. */}
      <div
        className="builder-text"
        dangerouslySetInnerHTML={{ __html: text?.toString() || "" }}
        style={{ outline: "none" }}
        suppressHydrationWarning
      />
    </div>
  );
};

Text.propTypes = {
  children: PropTypes.node,
  text: PropTypes.string,
};

export const TextDefinition = {
  name: "Text",
  component: Text,
  override: true,
  shouldReceiveBuilderProps: {
    builderBlock: false,
    builderContext: true,
  },
  static: true,
  isRSC: false,
  image:
    "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-text_fields-24px%20(1).svg?alt=media&token=12177b73-0ee3-42ca-98c6-0dd003de1929",
  inputs: [
    {
      name: "text",
      type: "html",
      required: true,
      autoFocus: true,
      bubble: true,
      defaultValue: "Enter some text...",
    },
  ],
} satisfies RegisteredComponent;

export default Text;
